import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';

class ViewCoverNoteContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.VIEW_COVER_NOTE}/>
        );
    }
}

export default ViewCoverNoteContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/ViewCoverNoteContainer.tsx